import { enGB } from 'date-fns/locale';
import CssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { ThemeProvider as LegacyThemeProvider } from '@mui/styles';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFnsV3';
import createTheme from './createTheme';

const StyleProvider = ({ children }) => {
  const theme = createTheme();

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
      <StyledEngineProvider injectFirst>
        <LegacyThemeProvider theme={theme}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            {children}
          </ThemeProvider>
        </LegacyThemeProvider>
      </StyledEngineProvider>
    </LocalizationProvider>
  );
};

export default StyleProvider;
